import { Component, OnInit } from '@angular/core';
import { OperationLogService } from '../../services/operation-log.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-air-company-note',
  templateUrl: './air-company-note.component.html',
  styleUrls: ['./air-company-note.component.scss'],
})
export class AirCompanyNoteComponent implements OnInit {
  airCompanyNotes$: Observable<string>;

  constructor(private service: OperationLogService) {}

  ngOnInit(): void {
    this.airCompanyNotes$ = this.service
      .getAirCompanyNotes()
      .pipe(
        map((text) => text.replace(new RegExp('\n', 'gi'), (match) => '<br>'))
      );
  }
}
